import { Box } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Tabs, { TabHeader, TabPanels } from 'components/Tabs';
import Title from 'components/Title';

import Advanced from './Advanced';
import General from './General';

const Notifications: React.FC<unknown> = () => {
  const { t } = useTranslation(['evv', 'common']);

  const tabHeaders = [{ label: t('common:general') }, { label: t('common:advanced') }];
  const tabPanels = [{ panel: <General /> }, { panel: <Advanced /> }];

  return (
    <>
      <Box mb="3">
        <Title hideBackButton={true}>Notification Settings</Title>
      </Box>

      <Tabs>
        <TabHeader tabHeaders={tabHeaders} />
        <TabPanels tabPanels={tabPanels} />
      </Tabs>
    </>
  );
};

export default Notifications;
